import adminHttp from "@/api/adminHttp";

const END_POINT = '/api/v1/admin/tournament-teams';

export default {
    addPoints: (id, params) => adminHttp.post(END_POINT + `/${id}/add-points`, params),
    getTournamentMlbbTeamsRating: (params) => adminHttp.get(END_POINT + `/${params.id}/points`, {params: params}),
}